export enum AiAgentStatusEnum {
    Enabled = 'Enabled',
    Disabled = 'Disabled'
}

export enum AiAgentEnum {
    AssessmentAutofill = 'assessment-auto-fill',
    VendorScoutAutofill = 'vendor-auto-fill',
    TiaCreate = 'tia-create',
    VendorRiskScoreCreate = 'vendor-risk-score-create',
    CopyReport = 'copy-report',
    EDiscoveryPdfScan = 'ediscovery-pdf-scan',
}

export enum AiAgentGroupTypeEnum {
    Proactive = 'proactiveAgents',
    Writing = 'writingAgents'
}

export enum AiAgentTaskStatusEnum{
    Success = 'Success',
    Error = 'Error',
	NotStarted = 'NotStarted',
	Undefined = 'Undefined',
	NoAction = 'NoAction',
    Change = 'Change'
}

export enum EntityTypeEnum {
    System = 'System',
    Assessment = 'Assessment'
}

export enum AiAgentBadgeTypeEnum {
    Running = 'Running',
    Edited = 'Edited'
}